// Stable, privacy-respecting device fingerprint used to curb multi-account abuse
// (people signing up repeatedly to farm free welcome credits). No external libs.
// Combines a canvas signature + stable hardware/locale traits, hashed with SHA-256.
// A copy is persisted in localStorage so the same browser keeps the same id.

const STORAGE_KEY = "imperium-did";

function canvasSignature() {
  try {
    const c = document.createElement("canvas");
    c.width = 240; c.height = 60;
    const ctx = c.getContext("2d");
    if (!ctx) return "no-canvas";
    ctx.textBaseline = "top";
    ctx.font = "16px 'Arial'";
    ctx.fillStyle = "#f60";
    ctx.fillRect(10, 10, 120, 30);
    ctx.fillStyle = "#069";
    ctx.fillText("Imperium·ECU·\u2699", 12, 14);
    ctx.fillStyle = "rgba(102,204,0,0.7)";
    ctx.fillText("\u2122\u00ae\u00a9 9F", 60, 24);
    return c.toDataURL();
  } catch {
    return "canvas-blocked";
  }
}

function traits() {
  const n = navigator || {};
  const s = window.screen || {};
  return [
    n.userAgent || "",
    n.platform || "",
    (n.languages || [n.language || ""]).join(","),
    String(n.hardwareConcurrency || ""),
    String(n.deviceMemory || ""),
    `${s.width || ""}x${s.height || ""}x${s.colorDepth || ""}`,
    String(new Date().getTimezoneOffset()),
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
  ].join("|");
}

async function sha256(str) {
  try {
    const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(str));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
  } catch {
    // Fallback: simple non-crypto hash (still stable per browser).
    let h = 5381;
    for (let i = 0; i < str.length; i++) h = (h * 33) ^ str.charCodeAt(i);
    return (h >>> 0).toString(16);
  }
}

export async function getDeviceId() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return saved;
  } catch { /* noop */ }
  const id = await sha256(`${traits()}::${canvasSignature()}`);
  try { localStorage.setItem(STORAGE_KEY, id); } catch { /* noop */ }
  return id;
}
